import Icon from 'components/Kizen/Icon';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  color: var(--color-font-primary);
  > :first-child {
    margin: 15px;
  }
`;

export const SummaryContainer = styled.div`
  margin: 15px 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HistoricalContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const HistoricalDatum = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  &:first-child {
    border-right: 1px solid var(--color-border-medium-light);
  }
`;

export const StyledTrendCaretIcon = styled(Icon)`
  font-size: inherit;
  height: inherit;
  width: inherit;
  vertical-align: middle;
  margin-right: 3px;
`;

export const getColor = (value, defined) => {
  if (!defined || value === 0) {
    return 'var(--color-font-primary)';
  }
  return value > 0
    ? 'var(--color-viz-cat-1-primary)'
    : 'var(--color-viz-cat-7-primary)';
};
